import { FormattedMessage } from 'react-intl'
import { ShareWithGroupsAlert } from './ShareWithGroupsAlert'
import DocLink from 'features/common/ui/utils/DocLink'
import { DOCS_SHARING_WITH_CERTAIN_GROUPS } from 'app/constants/urls'

export function ShareWithGroupsAlertNoGroups() {
  return (
    <ShareWithGroupsAlert>
      <FormattedMessage
        id="common.shareDialog.shareWithGroups.info.noGroups"
        values={{
          link: (content) => (
            <DocLink docUrl={DOCS_SHARING_WITH_CERTAIN_GROUPS} underline="none">
              {content}
            </DocLink>
          )
        }}
      />
    </ShareWithGroupsAlert>
  )
}
